import { EMPTY_ARRAY } from "@client/lib/array";
import { getSourceEntities, getSourceLocalSettings } from "@client/lib/entities";
import { isModuleEntity } from "@client/lib/layout";
import { type ModuleEntity, type WithPlace } from "@client/types";
import { createSelector } from "reselect";
import { createShallowEqualSelector } from "./common";
import { entitiesSourcePropsSelector, idPropsSelector, parentIdPropsSelector } from "./props";
import { activePopupSelector, componentsSelector, contentEntitiesSelector, contentLocalSelector } from "./state";

export const entitiesSelector = createSelector(
  [entitiesSourcePropsSelector, contentEntitiesSelector, activePopupSelector, componentsSelector],
  (source, contentEntities, activePopup, components) =>
    getSourceEntities(source, {
      activePopup,
      content: contentEntities,
      components: components
    })
  // TODO_NEXT3: improve memoization
);

export const localSettingsSelector = createSelector(
  [entitiesSourcePropsSelector, contentLocalSelector, activePopupSelector, componentsSelector],
  (source, content, activePopup, components) =>
    getSourceLocalSettings(source, {
      activePopup,
      content,
      components: components
    })
  // TODO_NEXT3: improve memoization
);

export const makeEntitySelector = () =>
  createSelector([entitiesSelector, idPropsSelector], (entities, id) => {
    if (!(id in entities)) debugger; // TODO_NEXT3: remove
    return entities[id];
  });
export const makeParentEntitySelector = () =>
  createSelector([entitiesSelector, parentIdPropsSelector], (entities, id) => entities[id]);
export const makeEntityTypeSelector = () => createSelector([makeEntitySelector()], (entity) => entity.type);
export const makeEntityOrientationSelector = () =>
  createSelector([makeEntitySelector()], (entity) => entity.orientation);
export const makeEntitySettingsSelector = () => createSelector([makeEntitySelector()], (entity) => entity.settings);
export const makeEntityDataSelector = <T>() => createSelector([makeEntitySelector()], (entity) => entity.data as T);

export const makeEntityLocalSettingsSelector = () =>
  createSelector([localSettingsSelector, idPropsSelector], (local, id) => (local ? local[id] : null));

export const makeModuleEntitySelector = () =>
  createSelector(
    [entitiesSelector, idPropsSelector],
    (entities, id) => (isModuleEntity(entities[id]) ? entities[id] : entities[entities[id].parentId!]) as ModuleEntity
  );

export const makeModuleTypeSelector = () => {
  const moduleEntitySelector = makeModuleEntitySelector();
  return createSelector([moduleEntitySelector], (moduleEntity) => moduleEntity.moduleType);
};

export const makeEntityChildrenIdsSelector = () => {
  const entitySelector = makeEntitySelector();
  return createSelector([entitySelector], (entity) => (entity.childrenIds ? entity.childrenIds : EMPTY_ARRAY));
};

export const makeEntityChildrenSelector = () => {
  const entityChildrenIdsSelector = makeEntityChildrenIdsSelector();

  return createShallowEqualSelector([entitiesSelector, entityChildrenIdsSelector], (entities, childrenIds) =>
    childrenIds.map((x) => entities[x])
  );
};

export const placeSelector = (state: any, props: WithPlace) => props.place;
